<template>
  <div class="sql-instanceBackup-page">
    <Card>
      <Row>
        <i-col span="21">
          <h1>{{this.$route.query.name}}</h1>
        </i-col>
        <i-col span="3">
          <Button style="float: right;" @click="refresh()" type="primary" :style="{marginBottom: '10px'}">刷新</Button>
        </i-col>
      </Row>
      <Divider />
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'

import {} from '@/api/sqlserver'

export default {
  name: 'sqlserverInstanceBackup',
  components: {
    Tables
  },
  data: function () {
    return {
      count: 1,
      size: 15,
      page: 1,
      dateValue: [new Date().toISOString().slice(0, 10), new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().slice(0, 10)],
      dateOption: {
        shortcuts: [
          {
            text: '今天',
            value () {
              const start = new Date()
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              return [start, end]
            }
          },
          {
            text: '三天',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
              return [start, end]
            }
          },
          {
            text: '一周',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
              return [start, end]
            }
          },
          {
            text: '一个月',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
              return [start, end]
            }
          },
          {
            text: '三个月',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
              return [start, end]
            }
          }
        ]
      },
      is_superuser: false
    }
  },
  methods: {
    searchReset () {
      this.searchForm.name = ''
    }
  },

  mounted: function () {
  }
}
</script>
<style lang="less">
 @media screen and (max-width:640px) {
  .sql-instanceBackup-page{
    .ivu-card-bordered,.ivu-table-wrapper{
      height:initial!important;
    }
    h1{
      font-size: 1.5em;
    }
    .ivu-divider-horizontal{
     margin:10px 0 15px;
    }
  }
}
</style>
